"use client";

import { useT } from "@tillix/i18n/react";
import {
  Collapsible,
  CollapsiblePanel,
  CollapsibleTrigger,
} from "@tillix/ui-atoms/atoms/collapsible";
import { ChevronDown, Mail, Phone } from "lucide-react";
import { QuickPaySection } from "@/features/quick-pay/quick-pay-section";
import {
  supportContacts,
  supportEmail,
} from "@/features/support/support-contact-data";

export default function AuthSidebarActions() {
  const { t } = useT();

  return (
    <div className="mx-auto mt-2 w-full max-w-md space-y-2 lg:mt-4 lg:space-y-4">
      {/* Quick Pay */}
      <div>
        <QuickPaySection />
      </div>

      {/* Contact */}
      <div className="text-white">
        <h2 className="mb-1 font-semibold text-xs uppercase md:text-sm">
          {t("auth.contact")}
        </h2>
        <p className="mb-1 text-xs md:text-sm">
          {t("auth.contactEmailPrefix")}{" "}
          <a
            className="inline items-center gap-1 text-[rgb(94,194,133)] hover:underline"
            href={`mailto:${supportEmail}`}
          >
            <Mail className="inline h-3.5 w-3.5" /> {supportEmail}
          </a>
        </p>

        <Collapsible>
          <CollapsibleTrigger className="flex w-full items-center justify-between rounded-md border border-white/20 px-2 py-1.5 font-medium text-white text-xs hover:bg-white/10 md:text-sm lg:px-3 lg:py-2">
            {t("auth.phoneNumbers")}
            <ChevronDown className="size-4 in-data-panel-open:rotate-180 transition-transform duration-200" />
          </CollapsibleTrigger>
          <CollapsiblePanel>
            <div className="scrollbar-minimal mt-2 max-h-40 overflow-y-auto rounded-md border border-white/20 [@media(min-height:900px)]:max-h-none">
              <div className="divide-y divide-white/20 px-3">
                {supportContacts.map((contact) => (
                  <div
                    className={`flex items-center justify-between py-1.5 text-xs md:text-sm lg:py-2 ${contact.isEmergency ? "text-red-500" : "text-white"}`}
                    key={contact.labelKey}
                  >
                    <span className="font-medium">{t(contact.labelKey)}</span>
                    <a
                      className="inline-flex items-center gap-1.5 hover:underline"
                      href={`tel:${contact.phone.replaceAll("-", "")}`}
                    >
                      <Phone className="h-3.5 w-3.5" />
                      {contact.phone}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </CollapsiblePanel>
        </Collapsible>
      </div>
    </div>
  );
}
